import 'css-chunksrc/client/pages/searchPage/searchResults/project/styles.scss';export default {
  "project": "_project_sj12v_1",
  "icon": "_icon_sj12v_14",
  "name": "_name_sj12v_22",
  "zone": "_zone_sj12v_27",
  "match": "_match_sj12v_34"
};